import * as React from 'react';
import {
    Button, ButtonType
} from 'office-ui-fabric-react';
import { IRedirectCandidate, ERedirectCandidateType, PropertyHelper } from '../../helpers/index';
import RedirectConfigContainer from '../../containers/redirect-config';

interface IProps {
    to?: IRedirectCandidate;
    message?: string;
    componentId: string;
    toggleRedirectConfigDialog: (componentId: string) => void;
}
let childElement: JSX.Element;

export class Redirect extends React.Component<IProps, any> {
    getChildren() {
        childElement = <RedirectConfigContainer />;
    }

    componentDidMount(): void {
        this.getChildren();
    }

    render() {

        let { toggleRedirectConfigDialog, componentId } = this.props;

        return <div>
            {childElement}

            {/* <Button buttonType={ ButtonType.primary }
                label='Configure Redirect'
                title='Configure Redirect'
                icon='Settings'
                onClick={ (e) => toggleRedirectConfigDialog(componentId) } /> */}
        </div>;
    }

}


// WEBPACK FOOTER //
// ./source/ts/components/components/redirect.tsx